import React from 'react';
import Modal from "../../../../component/modal/ModalTemplate";

class ChargeModalBeforeCreate extends React.Component {
    constructor(props){
        super(props);
        this.state = {}
    }// end constructor
    render(){
        const { isClose, isOpen } = this.props;
        return(
            <Modal className={"react-modal"}
                   open={isOpen}
                   handleClose={isClose}
                   modalTitle={""}
                   overlayClassName="modal-overlay"
            >
                <div className='modal-body'>
                    셀프 메시지 등록 이전 보유 금액을 꼭 확인 해주세요. <br/>
                    작성 중 충전 페이지 이동 시 입력한 메시지가 모두 삭제되니 꼭 금액 충전 후 메시지를 등록 해주세요!
                </div>
                <div className='modal-footer justify-content-center'>
                    <button className='btn btn-secondary btn-md me-2' onClick={isClose}>확인</button>
                    <button className='btn btn-primary btn-md' onClick={()=>window.location.href = "/cash/charge"}>충전하기</button>
                </div>
            </Modal>
        )
    }// end render
}// end class

export default ChargeModalBeforeCreate;
